import { createContext, useContext, useState } from 'react';

const PageCacheContext = createContext();

export const PageCacheProvider = ({ children }) => {
    const [cache, setCache] = useState({});

    const updatePageData = (pageKey, data) => {
        setCache((prev) => ({
            ...prev,
            [pageKey]: {
                data,
                lastUpdated: new Date(),
            },
        }));
    };

    const getPageData = (pageKey) => {
        return cache[pageKey]?.data || null;
    };

    return (
        <PageCacheContext.Provider value={{ getPageData, updatePageData }}>
            {children}
        </PageCacheContext.Provider>
    );
};

export const usePageCache = () => useContext(PageCacheContext);